import { render, staticRenderFns } from "./XmlViewerModal.vue?vue&type=template&id=17571c3a&scoped=true"
import script from "./XmlViewerModal.vue?vue&type=script&lang=js"
export * from "./XmlViewerModal.vue?vue&type=script&lang=js"
import style0 from "./XmlViewerModal.vue?vue&type=style&index=0&id=17571c3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17571c3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17571c3a')) {
      api.createRecord('17571c3a', component.options)
    } else {
      api.reload('17571c3a', component.options)
    }
    module.hot.accept("./XmlViewerModal.vue?vue&type=template&id=17571c3a&scoped=true", function () {
      api.rerender('17571c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/XmlViewer/XmlViewerModal.vue"
export default component.exports